@use '@furality/furality-purpose/scss/vars-for-modules' as purpose;

@include purpose.media-breakpoint-down(md) {
  .bannerPicture {
    padding-top: 2em;
  }
}
